<div class="row mobile_footer_spl">
    <div class="col-md-12 redirect_footerimagecontainer">
        <img class="redirect_footerlogo" title="" alt=""
            [src]="getImage(mobileFooterData.footerlogo)">
    </div>
    <div class="col-md-12 redirect_footertext">{{ mobileFooterData.heading1}}</div>
</div>
